import type {
  GetTableCoverQuery,
  GetTableCoverQueryVariables,
  GetTableCoversQuery,
  GetTableCoversQueryVariables,
} from '@/typings/domain'
import apolloClient from './apolloClient'
import GetTableCoverGQL from './graphql/GetTableCover.graphql'
import GetTableCoversGQL from './graphql/GetTableCovers.graphql'

export function getTableCovers(variables: GetTableCoversQueryVariables) {
  return apolloClient.query<GetTableCoversQuery, GetTableCoversQueryVariables>({
    query: GetTableCoversGQL,
    variables,
    fetchPolicy: 'no-cache',
  })
}

export function getTableCover(variables: GetTableCoverQueryVariables) {
  return apolloClient.query<GetTableCoverQuery, GetTableCoverQueryVariables>({
    query: GetTableCoverGQL,
    variables,
    fetchPolicy: 'no-cache',
  })
}
